/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'lined-arrow-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 19',
    data: '<g _fill="none" fill-rule="evenodd"><g _fill="#FFF"><g><path pid="0" d="M12.379 13.809l4.439-4.44 1.06-1.06L20 10.43l-1.06 1.06-5.975 5.975.035.035-2.121 2.121-.035-.035-.035.035L8.687 17.5l.035-.035-5.975-5.974-1.06-1.06 2.12-2.122 1.061 1.06 4.51 4.51V0h3v13.809z"/></g></g></g>'
  }
})
